import { NOTIFICATION_SEVERITY, type Notification } from './types';

const BASE_TIME_MS = Date.UTC(2026, 4, 11, 9, 0);
const MINUTE_MS = 60_000;

export const MOCK_NOTIFICATIONS: Notification[] = [
  {
    id: 'erasmus-mc-over-threshold',
    severity: NOTIFICATION_SEVERITY.Critical,
    titleKey: 'topbar.notifications.items.erasmus-mc-over-threshold.title',
    descriptionKey: 'topbar.notifications.items.erasmus-mc-over-threshold.description',
    href: '/cpo-analytics',
    occurredAt: new Date(BASE_TIME_MS).toISOString(),
    read: false,
  },
  {
    id: 'equinix-am4-grid-spike',
    severity: NOTIFICATION_SEVERITY.Critical,
    titleKey: 'topbar.notifications.items.equinix-am4-grid-spike.title',
    descriptionKey: 'topbar.notifications.items.equinix-am4-grid-spike.description',
    href: '/cpo-analytics',
    occurredAt: new Date(BASE_TIME_MS - 8 * MINUTE_MS).toISOString(),
    read: false,
  },
  {
    id: 'ing-csrd-attention',
    severity: NOTIFICATION_SEVERITY.Warning,
    titleKey: 'topbar.notifications.items.ing-csrd-attention.title',
    descriptionKey: 'topbar.notifications.items.ing-csrd-attention.description',
    href: '/billing/invoices',
    occurredAt: new Date(BASE_TIME_MS - 25 * MINUTE_MS).toISOString(),
    read: false,
  },
  {
    id: 'almere-pv-underperform',
    severity: NOTIFICATION_SEVERITY.Warning,
    titleKey: 'topbar.notifications.items.almere-pv-underperform.title',
    descriptionKey: 'topbar.notifications.items.almere-pv-underperform.description',
    href: '/cpo-analytics',
    occurredAt: new Date(BASE_TIME_MS - 47 * MINUTE_MS).toISOString(),
    read: false,
  },
  {
    id: 'noordereiland-meter-stale',
    severity: NOTIFICATION_SEVERITY.Warning,
    titleKey: 'topbar.notifications.items.noordereiland-meter-stale.title',
    descriptionKey: 'topbar.notifications.items.noordereiland-meter-stale.description',
    href: '/qr-payment',
    occurredAt: new Date(BASE_TIME_MS - 92 * MINUTE_MS).toISOString(),
    read: false,
  },
  {
    id: 'rotterdam-port-permit-due',
    severity: NOTIFICATION_SEVERITY.Info,
    titleKey: 'topbar.notifications.items.rotterdam-port-permit-due.title',
    descriptionKey: 'topbar.notifications.items.rotterdam-port-permit-due.description',
    href: '/billing/split-billing',
    occurredAt: new Date(BASE_TIME_MS - 4 * 60 * MINUTE_MS).toISOString(),
    read: false,
  },
  {
    id: 'leiden-bess-firmware',
    severity: NOTIFICATION_SEVERITY.Info,
    titleKey: 'topbar.notifications.items.leiden-bess-firmware.title',
    descriptionKey: 'topbar.notifications.items.leiden-bess-firmware.description',
    href: '/cpo-analytics',
    occurredAt: new Date(BASE_TIME_MS - 7 * 60 * MINUTE_MS).toISOString(),
    read: false,
  },
];
